export const initialState = {
  treatmentPlans: [],
  treatmentPlansDetail: {}
};
